import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../core/auth/service/auth.service';
import { Router } from '@angular/router';
import { MenuService } from './menu-bar.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.css']
})
export class MenuBarComponent implements OnInit {
  items: MenuItem[]= [];
  submenus: MenuItem[] = [];
  usuarioLogado: string | null;
  ambienteLogado!: string;
  exibeRegras: boolean = true;
  gruposUsuario: string[] = [];

  constructor(
  private auth: AuthService,
  private router: Router,
  private service: MenuService,
  private cdr: ChangeDetectorRef) {
    this.usuarioLogado = this.auth.obterUsuarioLogado();
    this.ambienteLogado = this.auth.obterAmbienteLogado();
    this.gruposUsuario = this.auth.obterGruposUsuario();
  }

  async ngOnInit() {
    if ((window as any).CustomGPT) {
      (window as any).CustomGPT.init({
        p_id: "31181",
        p_key: "6361edb62694125796dc022b9bb4569e",
        width: "400px",
        height: "700px"
      });
      setTimeout(() => {
        const chatElement = document.querySelector('.customgpt-chat');
        if (chatElement) {
          chatElement.classList.add('customgpt-position');
        }
      }, 1000); // Ajuste o tempo conforme necessário
    } else {
      console.error('CustomGPT script not loaded!');
    }

    this.submenus.push({
      label: "Configuração",
      icon: "pi pi-spin pi-cog",
      items: [{
        label: "CNPJ x Contribuinte",
        icon: "pi pi-building",
        command: () => this.router.navigate(['config-cnpj-estab'])
      },
      {
        label: "Importar Escopo TCO",
        icon: "pi pi-spin pi-cog",
        command: () => this.router.navigate(['config-definicao-prontidao'])
      }]
    });

    // Exibição condicional dos menus "Grupos" e "Usuários"
    if (this.usuarioLogado === 'admin' || this.gruposUsuario.includes('Avalara') || this.gruposUsuario.includes('Vetor')) {
      this.submenus.push({
        label: "Grupos",
        icon: 'pi pi-users',
        command: () => this.router.navigate(['manutencao-grupo'])
      });

      this.submenus.push({
        label: "Usuários",
        icon: 'pi pi-user',
        command: () => this.router.navigate(['manutencao-usuario'])
      });
    }

    this.submenus.push({
      label: "Processamento",
      icon: 'pi pi-desktop',
      command: () => this.router.navigate(['manutencao-processamento'])
    });

       this.submenus.push({
      label: "Ajuda",
      icon: 'pi pi-question-circle',
      url: 'ajuda'
    });

    this.items = [{
        label: "",
        icon: 'pi pi-bars',
        items: this.submenus
    }]
  }

  logout() {
    this.auth.destroySession();
    this.router.navigateByUrl('login');
  }
}
